import { GetComments as query } from "@graphql/queries";

const resultsExtractor = (data) => data?.getComments?.comments;
const moreRepliesExtractor = (data) => data?.getComments?.moreReplies;
const nextVariablesExtractor = (data) => data?.getComments?.nextVariables;

export const GetComments = {
  query,
  buildOptions: ({
    variables,
    fetchPolicy = "cache-and-network",
    nextFetchPolicy = "cache-first",
  }) => {
    const {
      post: { id: postId = null } = {},
      comment: { id: commentId = null } = {},
      comments = [],
      ancestor = null,
      decendent = null,
      maxDepth = null,
    } = variables;
    const commentIds = comments.map((comment) => comment.id);
    return {
      fetchPolicy,
      nextFetchPolicy,
      variables: {
        postId,
        commentId,
        commentIds,
        ancestor,
        decendent,
        maxDepth,
      },
    };
  },
  buildResult: (result) => {
    Object.assign(result, {
      query,
      resultsExtractor,
      nextVariablesExtractor,
      moreRepliesExtractor,
      results: resultsExtractor(result.data),
      // eslint-disable-next-line consistent-return
      fetchNext: () => {
        if (typeof result.fetchMore === "function") {
          const nextVariables = nextVariablesExtractor(result.data);
          const variables = JSON.parse(
            JSON.stringify(nextVariables, (k, v) =>
              k === "__typename" ? undefined : v
            )
          );
          return result.fetchMore({ variables });
        }
      },
    });
    return result;
  },
};
